export var MAX_REPEATS_X = Infinity;
export var MAX_REPEATS_Y = Infinity;
